import React from 'react';
import ReactDOM from 'react-dom';
import 'aos/dist/aos.css';
import './custom.scss';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
